import QuickReportParamsPrompt from "emun.report/quick-report-params";
import QuickReportPrompt from "emun.report/quick-report-prompt";
import AutoQuery from "servicestack/auto-query/auto-query";
import basicController from "servicestack/basic.controller.properties";
import ServiceBus from "servicestack/service-bus";
import modals from "webmodals/modals";

export default class QuickReportListController {
  constructor() {
    const $ctrl = this;
    basicController($ctrl);
    $ctrl.$on("quickReportSaved", () => $ctrl.query.load(true));
    $ctrl.bus = new ServiceBus();
  }
  $onInit() {
    const $ctrl = this;
    $ctrl.query = new AutoQuery({
      url: "QueryQuickReports.json?",
      hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
      orderBy: "Type,Name",
      sortOptions: {
        "Type,Name": "Name: A to Z",
        "-Type,Name": "Name: Z to A",
      },
      autoLoad: true,
      onLoaded(args) {
        if (!$ctrl.$session.hasPermission("ViewCRM")) {
          args.results = args.results.filter(r => r.type !== "Customer");
        }
        if ($ctrl.$session.hasRole("Sales Rep", "Rep", "Manager")) {
          $ctrl.reporData = [];
          args.results.forEach(function (report) {
            console.log("report", report);
            if (
              report.subType != undefined &&
              $ctrl.$session.hasRole(report.subType.split(","))
            ) {
              $ctrl.reporData.push(report);
            }
          });

          $ctrl.reports = _.groupBy($ctrl.reporData, "type");
        } else {
          $ctrl.reports = _.groupBy(args.results, "type");
        }
      },
      pageSize: 1000,
    });
  }
  load() {
    const $ctrl = this;
    $ctrl.query.load(true);
  }
  viewReport(report) {
    const $ctrl = this;
    var string = report.query;

    var arr = (string.match(/(?:^|[ ])@([a-zA-Z0-9]+)/gm) + "").split(",");
    console.info("arr", arr);
    console.info("arr", arr.length, arr[0]);
    //We want to by pass any rep/manager param if they are the the manager or rep
    if ($ctrl.$session.hasRole("Sales Rep", "Rep")) {
      arr = arr.filter(function(item) {
        return item.trim() !== "@RepID" && item.trim() !== "@repID";
      });
    }
    if ($ctrl.$session.hasRole("Manager")) {
      arr = arr.filter(function(item) {
        return item.trim() !== "@ManagerID" && item.trim() !== "@managerID";
      });
    }
    if (arr.length == 0 || (arr.length == 1 && arr[0] == "null")) {
      let url = $ctrl.$appConfig.resolveServiceUrl(
        "RunReport?reportName=QuickReport&displayName=" +
          report.name +
          " &output=xlsx&QuickReportID=" +
          report.id +
          "&QuickReportName=" +
          report.name
      );

      return (location.href = url);
    } else {
      QuickReportParamsPrompt.open({
        model: { params: arr, report: report },
      }).then(() => $ctrl.load());
    }
  }

  addReport() {
    const $ctrl = this;
    QuickReportPrompt.open({ report: "", reportId: "" });
  }

  editReport(report) {
    const $ctrl = this;
    QuickReportPrompt.open({ report: report, reportId: report.id });
  }

  deleteReport(report) {
    const $ctrl = this;
    return modals
      .confirm(
        "Are you sure you want to delete " + report.name,
        "Delete Quick Report?"
      )
      .result.then(function () {
        //console.info("delete it");
        $ctrl.bus
          .send("DeleteQuickReport.json", report)
          .then(function () {
            return $ctrl.query.load(true);
          })
          .catch();
      });
  }
}
